import React from "react";

/**
 * Function to render a male icon SVG component.
 *
 * @param {object} cls - The class name for styling the SVG component.
 * @return {JSX.Element} The male icon SVG component.
 */
export const MaleIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 25"
      fill="none"
      className={cls}
    >
      <path
        d="M15.0136 3.4H14.9136V3.5V4.9966V5.0966H15.0136H18.2039L13.3246 9.97592C10.517 7.82199 6.49103 8.31831 4.29272 11.1052C2.07601 13.9155 2.5572 17.9906 5.36743 20.2073C8.17766 22.424 12.2528 21.9428 14.4695 19.1326C16.3077 16.8022 16.3259 13.5246 14.5241 11.1755L19.4034 6.29616V9.48648V9.58648H19.5034H21H21.1V9.48648V4.9966C21.1 4.11481 20.3852 3.4 19.5034 3.4H15.0136ZM9.40112 19.8628C6.77008 19.8627 4.63724 17.7298 4.63724 15.0988C4.63724 12.4677 6.77015 10.3348 9.40125 10.3348C12.0323 10.3348 14.1652 12.4676 14.1653 15.0987C14.162 17.7285 12.0309 19.8596 9.40112 19.8628Z"
        fill="currentColor"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );
};
